package della8.core.native

import kotlinx.browser.window

actual fun clipboard(text: String): String {
    window.navigator.clipboard.writeText(text)
    return text
}